import React, { useRef, useState, useEffect } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";

import { Button, Fade, Paper, Popper, Tooltip } from "@material-ui/core";

import MaterialUiDropdownWrapper from "./styles/materialUiDropdown.style";

function Dropdown(props) {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);
  const prevOpen = useRef(open);

  const {
    autoClose,
    disabled,
    buttonClass,
    component,
    text,
    children,
    placement,
    startIcon,
    endIcon,
    analytics,
    tooltip,
    tooltipTitle,
    tooltipPlacement
  } = props;

  const closeOnClick = () => (autoClose ? setOpen(false) : null);

  const handleToggle = () => {
    if (analytics) analytics();
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  const elementProperties = {
    ref: anchorRef,
    onClick: handleToggle,
    disabled,
    "aria-controls": open ? "menu-list-grow" : undefined,
    "aria-haspopup": true,
    className: classnames("materialUi__dropdown--toggle", buttonClass, {
      "materialUi__dropdown--toggle--active": open
    })
  };
  if (startIcon) elementProperties["startIcon"] = startIcon;
  if (endIcon) elementProperties["endIcon"] = endIcon;
  if (!component) elementProperties["disableFocusRipple"] = true;

  const CMP = React.createElement(component || Button, elementProperties, text);

  return (
    <MaterialUiDropdownWrapper className="materialUi__dropdown">
      {tooltip ? (
        <Tooltip title={tooltipTitle} placement={tooltipPlacement} arrow>
          {CMP}
        </Tooltip>
      ) : (
        CMP
      )}

      <Popper
        open={open}
        anchorEl={anchorRef.current}
        transition
        disablePortal
        placement={placement}
        style={{ zIndex: 9999999 }}
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={0}>
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <div className="materialUi__dropdown--menu" onClick={closeOnClick}>
                  {children}
                </div>
              </ClickAwayListener>
            </Paper>
          </Fade>
        )}
      </Popper>
    </MaterialUiDropdownWrapper>
  );
}

Dropdown.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  children: PropTypes.node.isRequired,
  autoClose: PropTypes.bool,
  disabled: PropTypes.bool,
  buttonClass: PropTypes.string,
  component: PropTypes.any, // default is materia button. can provide any HTML valid element
  placement: PropTypes.string,
  startIcon: PropTypes.any, // only applies for material button
  endIcon: PropTypes.any, // only applies for material button,
  analytics: PropTypes.func,
  tooltip: PropTypes.bool,
  tooltipTitle: PropTypes.string,
  tooltipPlacement: PropTypes.string
};

Dropdown.defaultProps = {
  autoClose: false,
  disabled: false,
  buttonClass: "",
  component: "",
  placement: "bottom-start",
  startIcon: null,
  endIcon: null,
  analytics: null,
  tooltip: false,
  tooltipTitle: "",
  tooltipPlacement: "right"
};

export default Dropdown;
